import { JSONEditor } from "vanilla-jsoneditor"
import React from "react"
import { Flex } from "@chakra-ui/react"

export default function BIJSONEditor(props) {
  const refContainer = React.useRef(null)
  const refEditor = React.useRef(null)

  React.useEffect(() => {
    // create editor
    console.log("create editor", refContainer.current)
    refEditor.current = new JSONEditor({
      target: refContainer.current,
      props: {},
    })

    return () => {
      // destroy editor
      if (refEditor.current) {
        console.log("destroy editor")
        refEditor.current.destroy()
        refEditor.current = null
      }
    }
  }, [])

  // update props
  React.useEffect(() => {
    if (refEditor.current) {
      console.log("update props", props)
      refEditor.current.updateProps(props)
    }
  }, [props])

  return (
    <Flex
      flex={1}
      position="relative"
      height="100%"
      minHeight={0}
      ref={refContainer}
    />
  )
}
